import React from 'react'
import { Drawer as AntDrawer } from 'antd'
import { DrawerProps as AntDrawerProps } from 'antd/lib/drawer'

type Props = AntDrawerProps

export const Drawer: React.FC<Props> = ({
  children,
  className,
  closable,
  destroyOnClose,
  footer,
  placement,
  onClose,
  title,
  visible,
  width,
  height,
  zIndex,
  style,
  getContainer,
  closeIcon,
  bodyStyle,
  mask
}) => (
  <AntDrawer
    className={className}
    closable={closable}
    destroyOnClose={destroyOnClose}
    onClose={onClose}
    placement={placement}
    footer={footer}
    title={title}
    visible={visible}
    width={width}
    height={height}
    zIndex={zIndex}
    style={style}
    getContainer={getContainer}
    closeIcon={closeIcon}
    bodyStyle={bodyStyle}
    mask={mask}
  >
    {children}
  </AntDrawer>
)
